import React, { useEffect, useState } from "react";
import boardStyles from "./board.less";

function getMetricColor(value) {
  if (value > 0) {
    return boardStyles.profit;
  }
  if (value < 0) {
    return boardStyles.error;
  }
  return "";
}

export const MetricCurrency = ({
  value,
  withoutColor = false,
  currency = "",
}) => {
  const [data, setData] = useState({
    text: "",
    color: "",
  });

  useEffect(() => {
    setData({
      text: formatCurrency(value, withoutColor),
      color: withoutColor ? "" : getMetricColor(value),
    });
  }, [value, withoutColor]);

  return (
    <span className={data.color}>
      {currency} {data.text}
    </span>
  );
};

export const MetricPercent = ({ value, fractionDigits }) => {
  const [data, setData] = useState({
    text: "",
    color: "",
  });

  useEffect(() => {
    setData({
      text: formatPercent(value, fractionDigits),
      color: getMetricColor(value),
    });
  }, [value, fractionDigits]);

  return <span className={data.color}>{data.text}</span>;
};

export const MetricText = ({ value, currency = "" }) => {
  const [color, setColor] = useState("");

  useEffect(() => {
    setColor(getMetricColor(value));
  }, [value]);

  return (
    <span className={color}>
      {currency} {value}
    </span>
  );
};

export const formatPercent = (value, fractionDigits = 1) => {
  if (Number(value).toString() === "NaN") {
    return value;
  }
  let display = Math.abs(value).toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  display += "%";
  if (value < 0) {
    return `(${display})`;
  }
  return display;
};

export const formatCurrency = (value, onlyFormatValue) => {
  let number = Math.round(value);
  if (number.toString() === "NaN") {
    return value;
  }
  let display = Math.abs(number).toLocaleString("en-US");
  if (!onlyFormatValue && number < 0) {
    return `(${display})`;
  }
  return display;
};
